import React from "react";
import Navbar from "../../../Navbar/Navbar";
import Body from "./Body";
import Header from "./Header";
import Footer from "./Footer";

const AllCom = () => {
  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: "#2C3539" }}>
        <Header />
        <br></br>
        <div className="bg-white">
          <Body />
        </div>
        <br></br>
        <Footer />
      </div>
    </>
  );
};

export default AllCom;
